import styled from "styled-components";
import JobName from "./JobName";


function CharacterListContainer(props) {

    const className = JobName();

    return(
            <CharacterListContainerMaster>
              {      
                 props.userCharacters.map((e) => { 
                    if(e.account_id === props.itemAccount.account_id){

                        if(e.sex == "M") {
                            var hairUrl = `/char_skin/head_skin/m_idle/${e.hair}.png`;
                            var bodyUrl = `/char_skin/body_skin/m_idle/${e.class}.gif`;
                        } 
                        if(e.sex == "F"){
                            var hairUrl = `/char_skin/head_skin/f_idle/${e.hair}.png`;
                            var bodyUrl = `/char_skin/body_skin/f_idle/${e.class}.gif`;
                        }
                        if(e.sex == "M" && e.class == "4218") {
                            var hairUrl = `/char_skin/head_skin/m_summoner/${e.hair}.png`;
                        } 
                        if(e.sex == "M" && e.class == "4308") {
                            var hairUrl = `/char_skin/head_skin/m_summoner/${e.hair}.png`;
                        } 
                        if(e.sex == "F" && e.class == "4218" || e.class == "4308"){
                            var hairUrl = `/char_skin/head_skin/f_summoner/${e.hair}.png`;
                        }
                        if(e.sex == "F" && e.class == "4308"){
                            var hairUrl = `/char_skin/head_skin/f_summoner/${e.hair}.png`;
                        }

                        return <CharacterContainer>

                        <CharItemContainer>
                        <HeadContainer>
                        <ImgHead src={hairUrl}></ImgHead>
                        </HeadContainer>
                        <ImgBody src={bodyUrl}></ImgBody>
                        </CharItemContainer>

                        <CharacterName>{e.name}</CharacterName>
                        <CharInfoMasterContainer>
                                                        
                        <CharInfoColumnB>
                        <span>{className[e.class]}</span>
                        <span><b>{e.base_level}/{e.job_level}</b></span>
                        <span>{e.zeny.toLocaleString('pt-BR')} z</span>
                        <span>{e.last_map}</span>
                        </CharInfoColumnB>
                        </CharInfoMasterContainer>
                                                    
                        </CharacterContainer>
                        }
                    })   
             }
                                
            </CharacterListContainerMaster>

    );
}

export default CharacterListContainer;

const CharacterListContainerMaster = styled.div`
    display: flex;
    //flex-wrap: wrap;
    align-items: center;
    justify-content: left;
    padding: 1px 0px;
    margin-left: 0px;
    height: 100%;
    //overflow: hidden;
    position: absolute;
    //background-color: rgba(18, 93, 140, 0.2);
    border-radius: 10px;
    //border: solid 1px black;
    transition: .3s ease-in-out;
    
    
`

const CharacterContainer = styled.div`
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    width: 200px;
    height: 300px;
    margin: 40px 20px;
    align-items: center;
    justify-content: center;
    background-color: white;
    border-radius: 5px;
    //border: solid 1px black;
    transition: .3s ease-in-out;
    filter: saturate(70%);
    background-color: rgba(0, 0, 0, 0.7);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover {
        scale: 1.2;
        background-color: rgba(255, 255, 255, .2);
        //color: black;
        filter: saturate(120%);
    }
    
`

const CharItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    scale: 1.2;
    margin-bottom: 5px;

`

const ImgBody= styled.img`
    margin: 0;
    padding: 0;

`

const HeadContainer = styled.div`
    margin-bottom: -9px;
    margin-right: 4px;
    padding: 0px;
    width: 27px;
    height: 28px;
    overflow: hidden;
    position: relative;
    z-index: 1;
`

const ImgHead = styled.img`
    margin-bottom: -5px;
    padding: 0px;
    object-fit: cover;
    position: absolute;
    left: 1px;
`

const CharacterName = styled.h2`

`

const CharInfoMasterContainer = styled.div`
    display: flex;
    align-items: center;

`

const CharInfoColumnB = styled.div`
    display: flex;
    flex-direction: column;
    align-items: left;
    justify-content: center;

`

